import Client from "./client";

const baseUrl = `/api/1`;

function notification() {
  return {
    getNotifications: () => {
      const url = baseUrl + "/users/notifications/all";
      return Client.get(url);
    },
    getUnReadNotificationsByCount: ({ params }) => {
      const url = baseUrl + "/users/notifications/all/unread/" + params.count;
      return Client.get(url);
    },
    getUnReadNotifications: ({ params }) => {
      const url =
        baseUrl +
        `/users/notifications/all/unread/${params.pageSize}/${params.pageNumber}`;
      return Client.getWithoutLoading(url, params);
    },
    deleteAll: () => {
      const url = baseUrl + `/users/notifications`;
      return Client.delete(url);
    },
    readAll: () => {
      const url = baseUrl + `/users/notifications/status/readAll`;
      return Client.put(url);
    },
    getUnreadNotificationsCount: () => {
      const url = baseUrl + `/users/notifications/all/unread/count`;
      return Client.get(url);
    },
  };
}

export default notification();
